import { useMemo } from 'react';
import { useDisplayStore } from '@/stores/displayStore.js';
import { createFormatters, type Formatters } from './format.js';

/**
 * Hook that returns date formatters bound to the operator-selected timezone.
 * Pulls `tz` from displayStore so toggling in the Layout instantly re-renders
 * every timestamp on the page.
 */
export function useFmt(): Formatters {
  const tz = useDisplayStore((s) => s.tz);
  return useMemo(() => createFormatters(tz), [tz]);
}
